@if (copyInfo) {
  <div class="copyToClipboard__cont">
    @if (showCopyTooltip) {
      <div class="copyToClipboard__tooltip">
        <app-ds-tooltip
          [position]="tooltipPosition"
          [tooltip]="'COPY_REF' | transloco">
        </app-ds-tooltip>
      </div>
    }
    <div class="copyToClipboard__icon" #copyToClipboardRef (click)="copyToClipboard($event)">
      <app-ds-icon
        [icon]="icons.CopyToClipboard" 
        [color]="iconFillColor.Primary"
        [size]="24">
      </app-ds-icon>
    </div>
  </div>
}